import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditStoryForm} from '../../model';
import {StoryModel} from '../../../../entities';

interface EditStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  blockId: string;
  storyId: string | null;
  story?: StoryModel;
}

export const EditBlockStoryModal = ({open, setOpen, blockId, storyId, story}: EditStoryModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditStoryForm({blockId, storyId, setOpen, story});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'История',
    title: 'Ошибка при редактировании истории',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Очистка формы при закрытии модального окна
  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать историю'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Заголовок истории"
          placeholder="Заголовок истории"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <FormInput
          label="Приоритет"
          placeholder="Приоритет"
          name="priority"
          type="number"
          value={values.priority.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.priority && errors.priority}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
